<template>
	<div class="cart color-black">
		<div class="container">
			<div class="row">
				<div class="col-12 pl-0 pr-0 pt-2">
					<div class="col-12 pl-0 pr-0 mt-4 background-white cus-box-shadow rounded-top" v-if="shipMethod.code == 1">
						<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
							<div class="font-size-16 font-size-sm-14">Alamat Pengiriman</div>
						</div>
						<div class="col-12 pt-md-4 pt-3 pb-4 border-2 border-purple pl-0 pr-0 pl-md-3 pr-md-3">
							<div class="col-12 d-md-flex pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-lg-9 p-0 pl-lg-2 pr-lg-2">
									<div class="col-12 pl-0 pr-0 d-md-flex">
										<div class="col-12 col-md-6 col-lg-5 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-user mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Nama Penerima</div>
												<div class="col-12 p-0 color-black font-size-sm-10">{{isAuth ? userData.member_name :publicData.nama}}</div>
											</div>
										</div>
										<div class="col-12 col-md-6 col-lg-7 pr-0 pt-2 p-md-0 d-flex">
											<div class="col-1 p-0 text-center"><i class="fas fa-phone mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-11 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Nomor Handphone</div>
												<div class="col-11 p-0 color-black font-size-sm-10 f-lato">{{isAuth ? userData.member_mobilephone :publicData.phone}}</div>
											</div>
										</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-2 pt-md-4 d-flex">
										<div class="col-12 col-md-10 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-home mr-1 color-mila mt-2"></i></div>
											<div class="col-11 pl-md-0 ml-lg-n2">
												<div class="col-11 p-0 font-bold font-size-13 font-size-sm-11 color-mila ml-md-n1">Alamat</div>
												<div class="col-11 p-0 color-black font-size-sm-10 ml-md-n1">{{isAuth ? selectedAddress.address_detail +" "+ selectedAddress.subdistrict_name +" "+ selectedAddress.city_name +" "+ selectedAddress.province : courier.detail+" "+courier.district.subdistrict_name +" "+ courier.district.city_name+" "+courier.district.province}}</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-3 m-auto d-none d-lg-block">
									<div class="col-12 text-center">
										<img class="img-fluid" src="assets/icon/shipping-box.svg" alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-4 background-white cus-box-shadow rounded-top" v-if="shipMethod.code == '0'">
						<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
							<div class="font-size-16 font-size-sm-14">Alamat Pengambilan</div>
						</div>
						<div class="col-12 pt-md-4 pt-3 pb-4 border-2 border-purple pl-0 pr-0 pl-md-3 pr-md-3">
							<div class="col-12 d-md-flex pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-lg-9 p-0 pl-lg-2 pr-lg-2">
									<div class="col-12 pl-0 pr-0 d-md-flex">
										<div class="col-12 col-md-6 col-lg-5 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-user mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Nama Mobile Counter</div>
												<div class="col-12 p-0 color-black font-size-sm-10">{{stockistOne.stockist_name}}</div>
											</div>
										</div>
										<div class="col-12 col-md-6 col-lg-7 pr-0 pt-2 p-md-0 d-flex">
											<div class="col-1 p-0 text-center"><i class="fas fa-phone mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-11 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Nomor Handphone</div>
												<div class="col-11 p-0 color-black font-size-sm-10 f-lato">{{stockistOne.stockist_mobilephone}}</div>
											</div>
										</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-2 pt-md-4 d-md-flex">
										<div class="col-12 col-md-6 col-lg-5 pr-0 d-flex">
											<div class="col-1 p-0"><i class="fas fa-home mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-12 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Alamat</div>
												<div class="col-12 p-0 color-black font-size-sm-10">{{stockistOne.stockist_origin_address}} {{stockistOne.stockist_origin_subdistrict_name}} {{stockistOne.stockist_origin_city_name}} {{stockistOne.stockist_origin_province_name}}</div>
											</div>
										</div>
										<div class="col-12 col-md-6 col-lg-7 pr-0 pt-2 p-md-0 d-flex">
											<div class="col-1 p-0 text-center"><i class="fas fa-calendar-alt mr-1 color-mila mt-2"></i></div>
											<div class="col-11">
												<div class="col-11 p-0 font-bold font-size-13 font-size-sm-11 color-mila">Tanggal Pengambilan</div>
												<div class="col-11 p-0 color-black font-size-sm-10 f-lato">{{pickup.date | hariTanggal}}</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-3 m-auto d-none d-lg-block">
									<div class="col-12 text-center">
										<img class="img-fluid" src="assets/icon/pickUp.svg" alt="">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 p-0" v-if="step == 3">
						<div class="col-12 p-0 p-md-3 pb-md-4 mt-4 background-white cus-box-shadow rounded">
							<div class="col-12 d-md-flex pl-0 pr-0 pb-3 pl-lg-3 pr-lg-3">
								<div class="col-12 col-md-6 pt-2 pt-md-0">
									<div class="color-mila font-size-18 font-size-sm-12 font-weight-bold f-lato">{{cartOne.stockist_code}}</div>
									<div class="color-black font-size-14 font-size-sm-11 pt-1">{{cartOne.stockist_name}}</div>
								</div>
								<div class="col-12 col-md-6 text-md-right">
									<div class="col-12 mt-2 mt-md-3 pt-1 pr-0 pl-0 pl-md-3">
										<span class="background-gray-dark no-box-shadow rounded font-size-12 font-size-sm-10 color-white p-2 pl-3 pr-3" id="lokasi-stockist" v-if="cartOne.city && cartOne.province">
											<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2"/>
											{{cartOne.city}}, {{cartOne.province}}
										</span>
									</div>
								</div>
							</div>
							<div class="col-12 d-block d-md-none"><div class="col-12 border-bottom"></div></div>
							<div class="col-12 pl-0 pr-0 overflow-auto">
								<div class="col-12 p-0 pl-lg-3 pr-lg-3">
									<div class="col-12 d-none d-md-block"><div class="col-12 border-bottom"></div></div>
									<div class="col-12 d-flex text-center font-weight-bold font-size-sm-10">
										<div class="col-8 col-md-4 pt-3 pb-3">Item</div>
										<div class="col-5 col-md-3 pt-3 pb-3 text-right">Harga (Rp)</div>
										<div class="col-5 col-md-2 pt-3 pb-3 text-center">Jumlah</div>
										<div class="col-6 col-md-3 pt-3 pb-3 text-right pr-md-0">Sub Total (Rp)</div>
									</div>
									<div class="col-12 d-none d-md-block"><div class="col-12 border-bottom"></div></div>
								</div>
								<div class="col-12 p-0 pl-lg-3 pr-lg-3">
									<div class="col-12 pl-0 pr-0" v-for="(product, index) in cartOne.products" :key="index">
										<div class="col-12 d-flex pt-2 pb-2 font-size-sm-10">
											<div class="col-8 col-md-4 d-flex pl-0">
												<div class="col-4 col-md-3 pl-0 mt-auto mb-auto"><img class="img-fluid rounded" :src="product.product_image_filename" alt=""></div>
												<div class="col-8 col-md-9 mt-auto mb-auto pl-0 pr-0 text-left">{{product.product_name}}</div>
											</div>
											<div class="col-5 col-md-3 m-auto text-right f-lato"><span>{{product.product_price | toNumber}}</span></div>
											<div class="col-5 col-md-2 m-auto text-center f-lato">{{product.quantity}} {{ product.product_unit }}</div>
											<div class="col-6 col-md-3 m-auto text-right pr-md-0 f-lato">{{product.product_price * product.quantity | toNumber}}</div>
										</div>
									</div>
									<div class="col-12 pr-0 pl-0" v-if="!isAuth">
										<div class="col-12 d-flex pt-2 pb-2 font-size-sm-10">
											<div class="col-8 col-md-4 d-flex pl-0">
												<div class="col-4 col-md-3 pl-0 mt-auto mb-auto"><img class="img-fluid rounded" :src="registerItem.image" alt=""></div>
												<div class="col-8 col-md-9 mt-auto mb-auto pl-0 pr-0 text-left">{{registerItem.title}}</div>
											</div>
											<div class="col-5 col-md-3 mt-auto mb-auto text-right f-lato"><span>{{ registerItem.price | toNumber }}</span></div>
											<div class="col-5 col-md-2 mt-auto mb-auto text-center f-lato">{{registerItem.quantity}} {{registerItem.unit}}</div>
											<div class="col-6 col-md-3 mt-auto mb-auto text-right pr-md-0 f-lato">{{registerItem.price_total | toNumber}}</div>
										</div>
									</div>
									<div class="col-12 pl-0 pr-0" v-if="shipMethod.code == 1">
										<div class="col-12 d-flex pt-2 pb-2 font-size-sm-10">
											<div class="col-8 col-md-4 d-flex pl-0">
												<div class="col-4 col-md-3 pl-0 mt-auto mb-auto"><img class="img-fluid rounded" :src="'assets/kurir/'+courSelected.code.toLowerCase()+'.png'"></div>
												<div class="col-8 col-md-9 mt-auto mb-auto pl-0 pr-0">{{courSelected.service.toUpperCase()}} ({{courSelected.etd}})</div>
											</div>
											<div class="col-5 col-md-3 m-auto text-right f-lato"><span>{{ courSelected.cost / weightCour * 1000 | toNumber }}</span></div>
											<div class="col-5 col-md-2 m-auto text-center f-lato">{{weightCour | toKg}}</div>
											<div class="col-6 col-md-3 m-auto text-right pr-md-0 f-lato">{{courSelected.cost | toNumber}}</div>
										</div>
									</div>
									<!-- <div class="col-12 pt-2 pr-2" v-if="orderData.payment_method == 1">
										<div class="col-12 d-flex pb-2 border-bottom pl-0">
											<div class="col-1 pl-0 font-size-25 color-purple text-center"><i class="fas fa-coins"></i></div>
											<div class="col-3 m-auto pl-0 text-left">Kode Unik</div>
											<div class="col-3 m-auto pl-0 pr-4 text-right">{{orderData.price_unique |toNumber}}</div>
											<div class="col-1 m-auto"></div>
											<div class="col-3 m-auto pr-0 text-right">{{orderData.price_unique |toNumber}}</div>
										</div>
									</div> -->
								</div>
							</div>
							<div class="col-12">
								<div class="col-12 d-none d-lg-block"><div class="col-12 border-bottom"></div></div>
								<div class="col-12 pt-2 d-block d-lg-none border-bottom"></div>
							</div>
							<div class="col-12 d-md-flex pt-4 pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-md-4 col-lg-5 color-black">
									<div class="font-size-14 font-size-sm-12">Total Pembayaran</div>
									<div class="font-size-18 font-size-sm-14 f-lato">Rp {{priceTotal | toNumber}}</div>
								</div>
								<div class="col-12 col-md-8 col-lg-7 text-right">
									<div class="col-12 pt-3 pl-0 pr-0">
										<div class="col-12 col-md-3 btn btn-outline-danger rounded pt-2 pb-2 mr-3" @click="step_down()">
											<i class="fas fa-arrow-left mr-2"></i>
											<span class="font-size-12 font-size-sm-11">Kembali</span>
										</div>
										<div class="col-12 btn-group col-md-8 col-lg-7 pl-0 pl-md-2 pr-0 pt-3 pb-3 pt-md-0 pb-md-0 choose-payment">
											<button type="button" class="col-12 btn background-button-template dropdown-toggle color-white pt-2 pb-2 pl-4 pr-4 box-purple d-flex justify-content-between" data-toggle="dropdown">
												<span class="font-size-12 font-size-sm-11">{{payment_method.payment}}</span>
												<i class="fas fa-chevron-down mt-1"></i>
											</button>
											<div class="col-12 dropdown-menu">
												<a @click="changePayment(payment)" class="dropdown-item color-black d-flex" href="javascript:;" v-for="(payment,index) in listPaymentMethod" :key="index">
													<!-- <div class="col-2 pl-0 pr-0"><img class="img-fluid img-ship pr-3" :src="payment.img" alt=""></div> -->
													<div class="font-size-12 font-size-sm-11">{{payment.payment}}</div>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-4 background-white cus-box-shadow rounded-top" v-if="step == 3 && payment_method.code == 2">
						<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
							<div class="font-size-16 font-size-sm-14">Pilih Virtual Account Bank</div>
						</div>
						<div class="col-12 col-md-12 mt-3 pt-3 pt-md-0" v-if="Step3ErorMessage">
							<div class="col-12 col-md-11 pt-2 pb-2 alert alert-danger color-red font-size-11">
								<i class="fas fa-exclamation-circle mr-2"></i>
								<span>{{Step3ErorMessage}}</span>
							</div>
						</div>
						<div class="col-12 pt-4 pb-3 pl-1 pr-1 pl-md-3 pr-md-3">
							<div class="col-12 d-md-flex pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-md-6 list-bank">
									<div class="col-12 p-0" v-for="(va, index) in Virtual_Account" :key="index">
										<label class="product-name transfer color-black mb-0 pl-0" @click="changeTransfer(va.payment_value, va.tutorial)">
											<div class="background-white border-top z-index-1 pb-2 pb-md-0 pt-1">
												<h2 class="mb-0 d-flex">
													<input type="radio" name="radio">
													<span class="checkmark mt-2 mt-md-0 mt-lg-2"></span>
													<div class="col-3 offset-1"><img class="width-90 img-fluid pt-3 pt-md-0" :src="'assets/bank/'+va.payment_value.toLowerCase()+'.svg'" alt=""></div>
													<div class="col-9 font-size-12 color-black font-size-sm-10 m-auto">
														<div>{{ va.name }}</div>
													</div>
												</h2>
											</div>
										</label>
									</div>
								</div>
								<div class="col-12 col-md-6 m-auto pt-3 pt-md-0" v-if="paymenterror">
									<div class="col-12 col-md-11 pt-2 pb-2 alert alert-danger color-red font-size-11">
										<i class="fas fa-exclamation-circle mr-2"></i>
										<span>Anda harus memilih Virtual Account terlebih dahulu</span>
									</div>
								</div>
								<div class="col-12 col-md-6 mt-4 mt-md-0 font-size-sm-10 font-size-11" v-if="isTransfer">
									<div class="accordion cus-box-shadow" id="accordionVA">
										<div class="card" v-for="(tutor, index) in paymentTutorial" :key="index">
											<div class="card-header background-white-dark cursor-pointer" id="headingOne" data-toggle="collapse" :data-target="'#collapse'+index">
												<div class="color-purple d-flex justify-content-between">
													<div>{{tutor.via}}</div>
													<i class="fas fa-chevron-down mt-2"></i>
												</div>
											</div>
											<div :id="'collapse'+index" class="collapse" data-parent="#accordionVA">
												<div class="card-body">
													<li v-for="(text) in tutor.tutorial" :key="text"><span v-html="text"></span></li>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 text-center mt-3 pb-4">
							<!-- <button class="col-3 btn btn-outline-danger rounded pt-2 pb-2 mr-3" @click="step_down">
								<i class="fas fa-arrow-left mr-3"></i>
								<span class="font-size-12">Kembali</span>
							</button> -->
							<button class="col-11 col-md-3 btn background-button-template color-white pt-2 pb-2 box-purple" @click="bayarSekarang" :disabled="isAttempting">
								<i class="fas fa-wallet mr-3"></i>
								<span class="font-size-12 font-size-sm-11">Bayar Sekarang</span>
							</button>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-4 background-white cus-box-shadow rounded-top" v-if="step == 3  && payment_method.code == 1">
						<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
							<div class="font-size-16">Pilih Bank Pembayaran</div>
						</div>
						<div class="col-12 pt-4 pb-3 pl-1 pr-1 pl-md-3 pr-md-3">
							<div class="col-12 d-md-flex pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-md-6 list-bank">
									<div class="col-12 p-0" v-for="(bank, index) in listBank" :key="index">
										<label class="product-name transfer color-black mb-0 pl-0" @click="changeTransfer(bank.bank_account_id, bank.bank_account_tutorial)">
											<div class="background-white border-top z-index-1 pb-2 pb-md-0 pt-1">
												<h2 class="mb-0 d-flex">
													<input type="radio" name="radio">
													<span class="checkmark mt-2"></span>
													<div class="col-3 offset-1"><img class="width-90 img-fluid pt-3 pt-md-0" :src="'assets/bank/'+bank.bank_account_bank.toLowerCase()+'.svg'" alt=""></div>
													<div class="col-9 font-size-12 color-black font-size-sm-10 m-auto">
														<div><span class="f-lato">{{ bank.bank_account_no }}</span> a/n {{bank.bank_account_name}}</div>
													</div>
												</h2>
											</div>
										</label>
									</div>
								</div>
								<div class="col-12 col-md-6 m-auto pt-3 pt-md-0" v-if="paymenterror">
									<div class="col-12 col-md-11 pt-2 pb-2 alert alert-danger color-red font-size-11">
										<i class="fas fa-exclamation-circle mr-2"></i>Anda harus memilih bank pembayaran terlebih dahulu
									</div>
								</div>
								<div class="col-12 col-md-6 mt-4 mt-md-0 font-size-sm-10 font-size-11" v-if="isTransfer">
									<div class="accordion cus-box-shadow" id="accordionMandiri">
										<div class="card" v-for="(tutor, index) in paymentTutorial" :key="index">
											<div class="card-header background-white-dark cursor-pointer" id="headingOne" data-toggle="collapse" :data-target="'#collapse'+index">
												<div class="color-purple d-flex justify-content-between">
													<div>{{tutor.via}}</div>
													<i class="fas fa-chevron-down mt-2"></i>
												</div>
											</div>
											<div :id="'collapse'+index" class="collapse" data-parent="#accordionMandiri">
												<div class="card-body">
													<li v-for="(text) in tutor.tutorial" :key="text"><span v-html="text"></span></li>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 text-center mt-3 pb-4">
							<button class="col-11 col-md-3 btn background-button-template color-white pt-2 pb-2 box-purple" @click="bayarSekarang" :disabled="isAttempting">
								<i class="fas fa-wallet mr-3"></i>
								<span class="font-size-12">Bayar Sekarang</span>
							</button>
						</div>
					</div>
					<div class="col-12 p-0" v-if="step == 4 ">
						<div class="col-12 p-0 p-md-3 pb-md-4 mt-4 background-white cus-box-shadow rounded">
							<div class="col-12 d-md-flex pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-md-6 pt-2 pt-md-0">
									<div class="color-mila font-size-18 font-size-sm-11 font-weight-bold f-lato">{{orderData.stockist.stockist_code}}</div>
									<div class="color-black font-size-14 font-size-sm-11 pt-1">{{orderData.stockist.stockist_name}}</div>
								</div>
								<div class="col-12 col-md-6 text-md-right">
									<div class="col-12 mt-2 mt-md-3 pt-1 pr-0 pl-0 pl-md-3">
										<span class="background-gray-dark no-box-shadow rounded font-size-12 font-size-sm-10 color-white p-2 pl-3 pr-3" id="lokasi-stockist" v-if="orderData.stockist.city && orderData.stockist.province">
											<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="mr-2"/>
											{{orderData.stockist.city}}, {{orderData.stockist.province}}
										</span>
									</div>
								</div>
							</div>
							<div class="col-12 pl-0 pr-0 overflow-auto">
								<div class="col-12 pt-3 pl-0 pr-0 pl-lg-3 pr-lg-3">
									<div class="col-12 d-none d-md-block"><div class="col-12 border-bottom"></div></div>
									<div class="col-12 d-flex text-left font-weight-bold font-size-sm-10 pl-0 pl-md-3">
										<div class="col-7 col-md-4 pt-3 pb-3">Item</div>
										<div class="col-5 col-md-3 pr-0 pr-md-3 pt-3 pb-3 text-right">Harga (Rp)</div>
										<div class="col-4 col-md-2 pt-3 pb-3 text-center">Jumlah</div>
										<div class="col-5 col-md-3 pt-3 pb-3 text-right">Sub Total (Rp)</div>
									</div>
									<div class="col-12 d-none d-md-block"><div class="col-12 border-bottom"></div></div>
								</div>
								<div class="col-12 pl-0 pr-0 pl-lg-3 pr-lg-3">
									<div class="col-12">
										<div class="col-12 d-flex pb-2 pt-2 pl-0 pr-0 font-size-sm-10" v-for="(product, index) in orderData.product" :key="index">
											<!-- <div class="col-1 pl-0"><img class="img-fluid rounded" :src="product.product_image_filename" alt=""></div> -->
											<div class="col-7 col-md-4 pl-0 pl-md-3 mt-auto mb-auto text-left">{{product.product_name}}</div>
											<div class="col-5 col-md-3 pr-0 pr-md-3 mt-auto mb-auto text-right f-lato"><span>{{ product.product_price | toNumber }}</span></div>
											<div class="col-4 col-md-2 mt-auto mb-auto text-center f-lato">{{product.quantity}}</div>
											<div class="col-5 col-md-3 pr-1 pr-md-3 text-right f-lato">{{product.price_total | toNumber}}</div>
										</div>
									</div>
									<!-- <div class="col-12 pt-2 pr-2" v-if="orderData.shipping_method == 1">
										<div class="col-12 d-flex pb-2 border-bottom pl-0">
											<div class="col-1 pl-0"><img class="img-fluid rounded" :src="'assets/kurir/'+orderData.shipping_courier.shipping_name+'.png'" alt=""></div>
											<div class="col-3 m-auto pl-0">{{orderData.shipping_courier.shipping_service.toUpperCase()}} Hari)</div>
											<div class="col-3 m-auto pl-0 pr-4">{{orderData.shipping_courier.shipping_price_total |toNumber}}</div>
											<div class="col-1 m-auto">{{orderData.shipping_courier.shipping_weight / 1000}} kg</div>
											<div class="col-3 m-auto pr-0">{{orderData.shipping_courier.shipping_price_total |toNumber}}</div>
										</div>
									</div> -->
								</div>
							</div>
							<div class="col-12 d-flex pt-2 color-black pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-7 ml-3 d-none d-md-block"></div>
								<div class="col-12 col-md-5 ml-md-n3 font-size-sm-10">
									<div class="col-12 pl-0 pr-0 pt-2 pb-2 d-flex">
										<div class="col-5 p-0">Total Harga</div>
										<div class="col-7 text-right f-lato pr-0 pr-md-3">{{ orderData.price_total | toNumber }}</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-2 pb-2 d-flex py-1" v-if="orderData.shipping_method == 1">
										<div class="col-5 p-0">Total Ongkos Kirim</div>
										<div class="col-7 text-right f-lato pr-0 pr-md-3">{{ orderData.shipping_courier.shipping_price_total | toNumber }}</div>
									</div>
									<div class="col-12 p-0 d-flex pb-1 pb-md-1" v-if="orderData.price_unique">
										<div class="col-5 p-0">Kode Unik</div>
										<div class="col-7 text-right f-lato">{{ orderData.price_unique |toNumber }}</div>
									</div>
								</div>
							</div>
							<div class="col-12">
								<div class="col-12 d-none d-lg-block"><div class="col-12 border-bottom"></div></div>
								<div class="col-12 pt-2 d-block d-lg-none border-bottom"></div>
							</div>
							<div class="col-12 d-md-flex pt-md-4 pt-2 pb-md-0 pb-2 color-black pl-0 pr-0 pl-lg-3 pr-lg-3">
								<div class="col-12 col-md-6">
									<div class="col-12 pl-0 pl-lg-3 font-size-14 font-size-sm-12">Total Pembayaran</div>
								</div>
								<div class="col-12 col-md-6 text-md-right">
									<div class="col-12 font-size-18 font-size-sm-14 pl-0 pl-md-3 pr-0 pr-lg-3 f-lato">{{ orderData.price_grand_total | toNumber }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 pl-0 pr-0 mt-4 background-white cus-box-shadow rounded-top detail-transaksi" v-if="step == 4">
						<div class="col-12 background-purple color-white text-center rounded-top pt-2 pb-2">
							<div class="font-size-16 font-size-sm-14">Ringkasan Detail Transaksi</div>
						</div>
						<div class="col-12 pt-4 pb-3 pl-0 pr-0 pl-lg-3 pr-lg-3">
							<div class="col-12 d-md-flex">
								<div class="col-12 col-md-5 pl-0 pr-0 pl-md-3 pr-md-3">
									<div class="col-12 pl-0 pr-0">
										<div class="font-size-14 font-size-sm-11">Kode Transaksi</div>
										<div class="font-size-15 font-size-sm-12 font-weight-bold pt-1 f-lato">{{orderData.transaction_code}}</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-md-4 pt-3" v-if="orderData.payment_bank">
										<div class="font-size-14 font-size-sm-11">Transfer pembayaran</div>
										<div class="col-3 p-0 mt-md-n3 mt-n1 mb-n3 pt-1"><img class="img-fluid" :src="'assets/bank/'+orderData.payment_bank.bank_name.toLowerCase()+'.svg'" alt=""></div>
										<div class="font-size-15 font-size-sm-12 font-weight-bold pt-2 f-lato">{{orderData.payment_bank.bank_account_number}}</div>
										<div class="font-size-10 font-size-sm-9 pt-1">a/n {{orderData.payment_bank.bank_account_name}}</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-md-4 pt-3" v-if="orderData.payment_va">
										<div class="font-size-14 font-size-sm-11">Transfer pembayaran</div>
										<div class="col-3 p-0 mt-md-n3 mt-n1 mb-n3 pt-1"><img class="img-fluid" :src="orderData.payment_va.va_bank_image" alt=""></div>
										<div class="font-size-15 font-size-sm-12 font-weight-bold pt-2 f-lato">{{orderData.payment_va.va_number}}</div>
									</div>
									<div class="col-12 pl-0 pr-0 pt-md-4 pt-3">
										<div class="font-size-14 font-size-sm-11">Jumlah yang harus dibayar</div>
										<div class="font-size-15 font-size-sm-12 font-weight-bold pt-1 f-lato">Rp {{orderData.price_grand_total | toNumber}}</div>
									</div>
								</div>
								<div class="col-12 col-md-7 m-auto pt-4 pt-md-0 pl-0 pr-0 pl-md-3 pr-md-3">
									<count-down :date="orderData.payment_bank ? orderData.payment_bank.bank_expired : orderData.payment_va.va_expired"></count-down>
									<div class="col-12 background-yellow rounded pt-2 pb-2 text-center mt-3 font-size-sm-10">
										Pastikan pembayaran melalui {{orderData.payment_bank ? "Transfer Bank" : "Virtual Account"}} {{orderData.payment_bank ? orderData.payment_bank.bank_name : orderData.payment_va.va_bank}} sesuai dengan nomor dan nominal yang tertera.
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 text-center mt-4 pb-4">
							<router-link :to="{ name: 'home' }" class="col-12 col-md-4 col-lg-2 btn background-outline-template pt-2 pb-2 mr-md-4 box-purple">
								<i class="fas fa-shopping-cart mr-3"></i>
								<span class="font-size-12 font-size-sm-11">Kembali Belanja</span>
							</router-link>
							<a :href="orderData.download_pdf" target="_blank" class="col-12 col-md-4 col-lg-2 btn background-button-template color-white pt-2 pb-2 mt-3 mt-md-0 box-purple">
								<i class="fas fa-cloud-download-alt mr-3"></i>
								<span class="font-size-12 font-size-sm-11">Unduh Transaksi</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CountDown from '../CountDown.vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import $ from 'jquery';

export default {
	name: 'home',
	components: {
		CountDown
	},
	props:{
		shipMethod:{
			type: Object
		},
		pickup:{
			type: Object
		},
		publicData:{
			type: Object
		},
		courier:{
			type: Object
		}
	},
	data () {
		return {
			listPaymentMethod: [
			{code: 1, payment:'Transfer Bank', img:'assets/icon/pick-up.svg'},
			{code: 2, payment:'Virtual Account', img:'assets/icon/jasa-logistik.svg'}
			],
			payment_method: {
				code: '',
				payment:'Pilih Metode Pembayaran',
			},
			paymentTutorial:[],
			paymenterror: false,
			paymentValue: '',
			Virtual_Account: [
			// {
			// 	name: "Virtual Account Mandiri",
			// 	img : "assets/bank/mandiri.svg",
			// 	payment_value : 'mandiri',
			// 	tutorial:[
			// 	{"via":"ATM Mandiri",
			// 	"tutorial":["Kunjungi ATM Terdekat dan masukkan PIN Anda","Pilih Jenis Transaksi: Pilih Transfer","Pilih menu <b>Bayar/Beli</b>", "Pilih menu <b>Lainnya</b>, hingga menemukan menu <b>Multipayment</b>", "Masukkan penyedia Jasa Milagros ( Kode Biller 89611 ), lalu pilih Benar", "Masukkan kode pembayaran dengan  Nomor <b>Virtual Account</b> Anda dan klik Benar", "Masukkan Angka <b>1</b> untuk memilih tagihan, lalu pilih tombol Ya", "Transaksi Berhasil"]},
			// 	{"via":"Internet Banking Mandiri/Mandiri Online",
			// 	"tutorial":["Buka www.ib.bankmandiri.co.id", "Masukkan username dan PIN Mandiri Anda", "Pilih menu <b>Bayar/Beli</b>", "Pilih menu <b>Lainnya</b>, hingga menemukan menu <b>Multipayment</b>", "Pilih rekening yang Anda akan melakukan Transaksi", "Masukkan penyedia Jasa Milagros ( Kode Biller 89611 ), lalu pilih Benar", "Masukkan kode pembayaran dengan  Nomor <b>Virtual Account</b> Anda dan klik Benar", "Setelah muncul tagihan klik centang , pilih Lanjutkan", "Masukkan beberapa angka challenge code yang terlihat di halaman transfer ke dalam token. Tunggu beberapa detik sampai muncul kode otomatis di token", "Masukkan kode di token ke laman transfer Anda, kemudian klik <b>LANJUTKAN</b>", "Transaksi Berhasil."]},
			// 	{"via":"Mandiri Mobile Banking",
			// 	"tutorial":["Login ke Akun Mandiri Mobile Anda","Masukkan username dan PIN Mandiri Anda","Pilih menu Bayar", "Pilih menu Multipayment", "Pilih penyedia Jasa Milagros ( Kode Biller 89611 )", "Masukkan kode pembayaran dan review Pembayaran Anda", "Isikan PIN Anda", "Transaksi Anda berhasil"]}
			// 	]
			// },
			{
				name: "Virtual Account BCA",
				img : "assets/bank/bca.svg",
				payment_value : 'bca',
				tutorial:[
				{"via":"ATM BCA",
				"tutorial":["Kunjungi ATM Terdekat dan masukkan PIN Anda","Pada menu utama, pilih menu <b> Transaksi Lainnya </b>","Pilih menu <b>Transfer</b> dan kemudian pilih <b>BCA Virtual Account</b>", "Masukkan no. BCA Virtual Account Anda  & klik <b>Lanjutkan</b>", "Periksa kembali rincian pembayaran Anda, lalu pilih Ya", "Transaksi Anda berhasil"]},
				{"via":"Klik BCA",
				"tutorial":["Login pada aplikasi KlikBCA, masukkan user ID & PIN.", "Pilih <b>Transfer Dana</b>, kemudian pilih <b>Transfer ke BCA Virtual Account</b>.", "Masukkan no. BCA Virtual Account Anda  & klik <b>Lanjutkan</b>.", "Periksa rincian pembayaran Anda & klik <b>Lanjut</b>", "Pastikan data yang dimasukkan sudah benar, dan Input <b>Respon KeyBCA</b>, lalu klik <b>Kirim</b>", "Transaksi Berhasil."]},
				{"via":"Mobile BCA",
				"tutorial":["Login pada aplikasi M-BCA, masukkan PIN M-BCA.","Pilih <b>m-Transfer</b>, pilih <b>BCA Virtual Account</b>.","Klik <b>Input no. Virtual Account</b>, lalu masukkan no BCA Virtual Account Anda", "Klik <b>OK</b> & <b>Send</b>.", "Periksa rincian pembayaran Anda kemudian pilih <b>OK<b> kemudian masukkan PIN M-BCA Anda.", "Periksa kembali data transaksi Anda, kemudian klik <b>OK</b>", "Transaksi Anda berhasil"]}
				]
			},
			],
			isTransfer: false,
		}
	},
	methods: {
		...mapActions('bank', ['getBank']),
		...mapActions('cart', ['postPickup', 'postShipping', 'deleteCart']),
		...mapMutations('cart', ['step_down', 'setpaymentSuccess']),

		changePayment(val){
			this.paymentValue = '';
			this.paymenterror = false;
			this.paymentTutorial = []
			this.payment_method = val
			setTimeout( function(){
				var cp = $('.choose-payment').offset().top
				$('html').scrollTop(cp)
			}, 100)
		},
		changeTransfer(val, tutorial) {
			this.paymenterror = false
			this.isTransfer = true
			this.paymentValue = val;
			this.paymentTutorial = tutorial
		},
		bayarSekarang() {
			if(!this.paymentValue){
				this.paymenterror = true
			} else {
				if(this.isAuth){
					if(this.shipMethod.code === 0){
						let paymentData = {
							member : true,
							params : {
								stockist_id: this.cartOne.stockist_network_id,
								name: this.userData.member_name,
								email: this.userData.member_email,
								mobilephone: this.userData.member_mobilephone,
								payment_method: this.payment_method.code,
								payment_method_value: this.paymentValue,
								pickup_date: moment(this.pickup.date).format('YYYY-MM-DD'),
								product: this.product
							}
						}
						this.postPickup(paymentData)
					} else if(this.shipMethod.code === 1){
						let paymentData = {
							member : true,
							params : {
								stockist_id: this.cartOne.stockist_network_id,
								name: this.userData.member_name,
								email: this.userData.member_email,
								mobilephone: this.userData.member_mobilephone,
								payment_method: this.payment_method.code,
								payment_method_value: this.paymentValue,
								origin_id: this.stockistOne.stockist_origin_subdistrict_id,
								province_id: this.selectedAddress.address_province_id,
								city_id: this.selectedAddress.address_city_id,
								subdistrict_id: this.selectedAddress.address_district_id,
								address: this.selectedAddress.address_detail,
								zipcode: this.selectedAddress.address_zipcode,
								shipping_name: this.courSelected.code,
								shipping_service: this.courSelected.service +' ('+ this.courSelected.etd+')',
								shipping_price: this.courSelected.cost,
								product: this.product
							}
						}
						this.postShipping(paymentData)
					}
				} else {
					if(this.shipMethod.code === 0){
						let paymentData = {
							member : false,
							params : {
								stockist_id: this.cartOne.stockist_network_id,
								name: this.publicData.nama,
								email: this.publicData.email,
								sponsor_mid: this.sponsorMLM.network_mid,
								mobilephone: this.publicData.phone,
								payment_method: this.payment_method.code,
								payment_method_value: this.paymentValue,
								pickup_date: moment(this.pickup.date).format('YYYY-MM-DD'),
								register_ktp:this.publicData.ktpNumber,
								product: this.product,
							}
						}
						this.postPickup(paymentData)
					} else if(this.shipMethod.code === 1){
						let paymentData = {
							member : false,
							params : {
								stockist_id: this.cartOne.stockist_network_id,
								name: this.publicData.nama,
								email: this.publicData.email,
								mobilephone: this.publicData.phone,
								sponsor_mid: this.sponsorMLM.network_mid,
								payment_method: this.payment_method.code,
								payment_method_value: this.paymentValue,
								origin_id: this.stockistOne.stockist_origin_subdistrict_id,
								province_id: this.courier.prov,
								city_id: this.courier.city,
								subdistrict_id: this.courier.district.subdistrict_id,
								address: this.courier.detail,
								zipcode: this.courier.district.postal_code,
								shipping_name: this.courSelected.code,
								shipping_service: this.courSelected.service +' ('+ this.courSelected.etd+')',
								shipping_price: this.courSelected.cost,
								register_ktp:this.publicData.ktpNumber,
								product: this.product
							}
						}
						this.postShipping(paymentData)
					}
				}
				setTimeout( function(){
					var dt = $('.detail-transaksi').offset().top
					$('html').scrollTop(dt - 100)
				}, 100)
			}
		}
	},
	computed: {
		...mapState('bank', ['listBank']),
		...mapState('cart', ['paymentSuccess', 'cartOne', 'orderData', 'courSelected', 'step', 'registerItem', 'isAttempting', 'sponsorMLM', 'Step3ErorMessage']),
		...mapGetters('auth', ['isAuth']),
		...mapState('auth', ['userData']),
		...mapState('address', ['selectedAddress']),
		...mapState('stockist', ['stockistOne']),

		product(){
			let product = [... this.cartOne.products]
			product.forEach(el => {
				delete el["product_description"];
				delete el["product_is_serial"];
				delete el["stock_store"];
				delete el["product_image_filename"];
			});
			return product
		},
		priceTotal() {
			var price = 0
			this.cartOne.products.forEach(el => {
				price += parseInt(el.product_price) * parseInt(el.quantity)
			});
			if (!this.isAuth) {
				price += this.registerItem.price_total
			}
			if (this.shipMethod.code == 1) {
				price += this.courSelected.cost
			}
			return price;
		},
		weightCour(){
			var weight = 0
			this.cartOne.products.forEach(el => {
				weight += parseInt(el.product_weight) * el.quantity
			});
			if (!this.isAuth) {
				weight += this.registerItem.weight
			}
			if(weight >= 1000){
				return (Math.ceil(weight / 1000)) * 1000
			} else {
				return 1000
			}
		},
	},
	created: function () {
		this.getBank();
		$('html').scrollTop(0)
	},
	mounted(){
	},
	watch: {
		paymentSuccess: function() {
			if(this.paymentSuccess){
				this.deleteCart({stockist_code:this.cartOne.stockist_code})
				return
			}
		}
	},
	filters: {
		truncate: function (text, length, suffix) {
			return text.substring(0, length) + suffix;
		},
	}
}
</script>

<style scoped>
.dropdown-item:hover {
	background-color: #7C1CC6;
	color: #ffffff !important;
}
.dropdown-menu .dropdown-item:hover .img-ship {
	filter: brightness(0) invert(1);
}
.dropdown-toggle::after {
	display: none;
}
.active-address {
	border: 2px solid #b730d1 !important;
	border-left-width: 10px !important;
}
.list-bank .checkmark {
	top: 20px;
	height: 15px;
	width: 15px;
	background-color: #ffffff;
	border: 1px solid #b730d1;
}
.product-name:hover input ~ .checkmark {
	background-color: #7C1CC6;
}
.transfer .checkmark {
	top: 17px;
	height: 15px;
	width: 15px;
}
.transfer .checkmark::after {
	border: none;
}
.address {
	min-height: 25rem;
	max-height: 25rem;
	overflow-y: auto;
}
</style>